/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceSecretManagerCredentialsInfo } from './resourceSecretManagerCredentialsInfo';
import { ResourceProvider } from './resourceProvider';
import { ResourceAssignmentState } from './resourceAssignmentState';
import { ResourceState } from './resourceState';
import { ResourceType } from './resourceType';
import { ResourceCategory } from './resourceCategory';


export interface VcfOrgResourceInfo { 
    assigned_by?: string;
    assigned_time?: Date;
    assignment_state?: ResourceAssignmentState;
    category?: ResourceCategory;
    managed?: boolean;
    metadata?: object;
    provider?: ResourceProvider;
    resource_id?: string;
    secret_manager_credentials?: Array<ResourceSecretManagerCredentialsInfo>;
    state?: ResourceState;
    type?: ResourceType;
    vcf_org_id?: string;
}
export namespace VcfOrgResourceInfo {
}


